import React from "react";
import Spinner from "./Spinner";

export default function PremLoading(props) {
  return (
    <div style={{ textAlign: "center", padding: "28px 0" }}>
      <Spinner size={32} />
      <div style={{ fontSize: 12, color: "#7a6e64", marginTop: 10 }}>{props.msg}</div>
    </div>
  );
}
